import { getPathAPI, getAuthHeaders, triggerBlobDownload } from "@/helpers";
import axios, { AxiosResponse } from "axios";
import { capitalize } from "lodash";
import BaseCollectionService from "./base.collection.service";

class ChartService extends BaseCollectionService {
  constructor() {
    super("chart");
  }
  public async exportChart(payload: any): Promise<AxiosResponse> {
    const path = `/chart/export/${payload.id}`;
    const response = await axios({
      url: `${getPathAPI()}${path}`,
      params: payload,
      method: "GET",
      responseType: "blob",
      headers: getAuthHeaders()
    });
    triggerBlobDownload(
      response.data,
      `${capitalize(`${new Date().toUTCString()}`)}-chart.csv`
    );
    return response;
  }
}

export default new ChartService();
